import React from 'react';
import LegalLayout from './LegalLayout';

export default function Imprint() {
  return (
    <LegalLayout title="Aviso Legal">
      <section className="space-y-4">
        <h2 className="text-xl font-serif text-etera-black">Titularidad del Sitio Web</h2>
        <p>
          En cumplimiento del deber de información recogido en el artículo 10 de la Ley 34/2002, de 11 de julio, de Servicios de la Sociedad de la Información y del Comercio Electrónico, se detallan a continuación los datos del titular:
        </p>
        <ul className="list-none space-y-2 text-etera-charcoal">
          <li><strong>Titular:</strong> Gisselle Mendez</li>
          <li><strong>Domicilio:</strong> Nemesi Valls 44 Attico 2, 08210 Barberà del Vallès</li>
          <li><strong>Barcelona, España</strong></li>
          <li>
            <strong>Contacto:</strong>{' '}
            <a href="mailto:contact@eteradragonhouse.com" className="hover:text-etera-gold underline transition-colors">
              contact@eteradragonhouse.com
            </a>
          </li>
        </ul>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-serif text-etera-black">Condiciones de Uso</h2>
        <p>
          El acceso y uso de este sitio web atribuye la condición de usuario, que acepta, desde dicho acceso y/o uso, las condiciones generales de uso aquí reflejadas.
        </p>
        <p>
          ÉTERA Dragon House proporciona el acceso a multitud de informaciones, servicios o datos en Internet pertenecientes a Gisselle Mendez o a sus licenciantes a los que el usuario pueda tener acceso.
        </p>
      </section>

      <section className="space-y-4">
        <h2 className="text-xl font-serif text-etera-black">Propiedad Intelectual</h2>
        <p>
          Gisselle Mendez por sí o como cesionaria, es titular de todos los derechos de propiedad intelectual e industrial de su página web, así como de los elementos contenidos en la misma (a título enunciativo, imágenes, sonido, audio, vídeo, marcas o logotipos, combinaciones de colores, estructura y diseño, selección de materiales usados, etc.).
        </p>
      </section>
    </LegalLayout>
  );
}